import { useState } from "react";
import { Box, Alert, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslationApp } from "../../lib/i18next";
import { useSelectorApp, useDispatchApp } from "../../lib/redux";
import {
  setModalOpenState,
  setShowModalSelectSubscription,
} from "../../actions/ui";
import {
  STORAGE_FULL_TITLE,
  STORAGE_FULL_MESSAGE,
  STORAGE_FULL_BUTTON_DELETE,
  STORAGE_FULL_BUTTON_UPGRADE,
} from "../../i18n/keysTranslations";
import Button from "../Buttons/Button";
import ModalGallery from "../Modal/ModalGallery";

const PanelStorageFull = () => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const isPanelStorageFull = useSelectorApp(
    (state) => state.ui?.openModals?.isPanelStorageFull ?? false
  );
  const [modalGalleryOpen, setModalGalleryOpen] = useState(false);

  if (!isPanelStorageFull && !modalGalleryOpen) return null;

  const onClosePanel = () => {
    dispatch(setModalOpenState("isPanelStorageFull", false));
  };

  const onUpgradePlan = () => {
    dispatch(setModalOpenState("isPanelStorageFull", false));
    dispatch(setShowModalSelectSubscription(true));
  };

  return (
    <>
      {modalGalleryOpen && (
        <ModalGallery
          modalOpen={modalGalleryOpen}
          onCloseModal={() => setModalGalleryOpen(false)}
        />
      )}

      {isPanelStorageFull && (
        <Box
          className="animate__animated animate__heartBeat"
          sx={{
            position: "fixed",
            bottom: 24,
            right: 16,
            zIndex: 1600,
            maxWidth: 600,
          }}
        >
          <Alert
            severity="warning"
            sx={{
              backgroundColor: "#fff",
              color: "text.primary",
              borderRadius: 2,
              boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
              "& .MuiAlert-icon": { color: "warning.main" },
            }}
            action={
              <IconButton
                size="small"
                aria-label="close"
                onClick={onClosePanel}
                sx={{ color: "text.secondary" }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 0.5 }}>
              {t(STORAGE_FULL_TITLE)}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1.5 }}>
              {t(STORAGE_FULL_MESSAGE)}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1,
              }}
            >
              <Button
                size="small"
                color="secondary"
                onClick={onClosePanel}
                sx={{
                  height: 38,
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                {t(STORAGE_FULL_BUTTON_DELETE)}
              </Button>
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={onUpgradePlan}
                sx={{
                  height: 38,
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                {t(STORAGE_FULL_BUTTON_UPGRADE)}
              </Button>
            </Box>
          </Alert>
        </Box>
      )}
    </>
  );
};

export default PanelStorageFull;
